import React from 'react'
import { Modal } from 'antd'
import Phq9Results from './phq9-results'
import Gad7Results from './gad-7-calc'
import CadsResults from './cads-results'
import CssrsResults from './cssrs-results'
import SatisfaccionResults from './satisfaccion-results'
import Dolor2Results from '../emt/dolor-results'
import EmcaResults from './emca-results'
import PostTraumaticoResults from './post_traumatico-results'

export default function KetaScalaDetailsModal({ isDetailsKetaScalaModalOpen, handleCancel, encuestaDetails }) {

    if (!encuestaDetails) return null

    const encuesta = encuestaDetails[0]
    const tipo = encuesta?.tipo

    const calculateResults = () => {
        switch (tipo) {
            case 'phq9p':
                return <Phq9Results phq9={encuesta.phq9p} />
            case 'gad_7':
                return <Gad7Results gad7={encuesta.gad_7} />
            case 'cadss':
                return <CadsResults cads={encuesta.cadss} />
            case 'cssrs':
                return <CssrsResults cssrs={encuesta.cssrs} />
            case 'satisfaccion_2':
                return <SatisfaccionResults satisfaccion={encuesta.satisfaccion_2} />
            case 'dolor_2':
                return <Dolor2Results escalaDetails={encuesta.dolor_2} />
            case 'emca':
                return <EmcaResults emca={encuesta.emca} /> // PENDING
            case 'post_traumatico':
                return <PostTraumaticoResults post_traumatico={encuesta.respuestas_ept1_davidson} /> // PENDING
            default:
                return null
        }
    }

    return (
        <Modal
            closable={{ 'aria-label': 'Custom Close Button' }}
            open={isDetailsKetaScalaModalOpen}
            onCancel={handleCancel}
            footer={[]}
            title='Detalles de la escala'
            width={1000}
        >
            <div>

                {/* Contain the ketamina results keta results */}

                {/* <p> {JSON.stringify(encuestaDetails)} </p> */}
                <p>Escala: {tipo}</p>
                <p>Fecha: {new Date(encuesta?.createdAt).toLocaleDateString('es-MX')} {new Date(encuesta?.createdAt).toLocaleTimeString('es-MX')}</p>


                {/* Example of encuestaDetails: [{"_id":"697bb9f2a9286c4b1e60b3b9","usuario":"690c12c60078302b35516f9f","medico":"69740e6237d353fe89a9ff82","tipo":"phq9p","visita":"695e77b51ed6a190fcc740af","sesion":"1","protocolo":"default","cat":[],"phq9p":[1,1,1,1,1,1,1,1,1],"efectos_emt":[],"uuid":"Ketamina","createdAt":"2026-01-29T19:50:10.161Z","updatedAt":"2026-01-29T19:50:10.161Z","__v":0}] */}
                {/* Another example: [{"efectos_emt":[],"_id":"695e781e1ed6a190fcc740c5","usuario":"690c12c60078302b35516f9f","medico":"690c12960078302b35516f8f","tipo":"gad_7","visita":"690c15fa6cd5fd8414e4df36","sesion":"1","protocolo":"default","cat":[],"gad_7":[0,1,0,1,1,1,1],"uuid":"Ketamina","createdAt":"2026-01-07T15:13:34.140Z","updatedAt":"2026-01-07T15:13:34.140Z","__v":0}] */}


                {
                    calculateResults()
                }
                <br />

                {/* <br />
                    <span>fecha y hora {new Date().toLocaleDateString('es-MX')} {new Date().toLocaleTimeString('es-MX')}</span> */}
            </div>
        </Modal>
    )
}